
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./apertum-tokenlist.cjs.production.min.js')
} else {
  module.exports = require('./apertum-tokenlist.cjs.development.js')
}
